import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import TaxonForm from "./TaxonForm";
import { addTaxonThunk } from "../../../actions/taxon";
import { toast } from "react-toastify";

function Taxons() {
  const tree_detail = useSelector(state => state.treeDetail);
  const primary_taxon = useSelector(state => state.treeDetail.primary_taxon);
  const other_taxa = useSelector(state => state.treeDetail.other_taxa);
  const taxons = useSelector(state => {
    const other = state?.treeDetail?.other_taxa;
    const primary = state?.treeDetail?.primary_taxon;

    if (other && primary) {
      return [primary, ...other];
    } else if (other) {
      return other;
    } else if (primary) {
      return [primary];
    } else {
      return [];
    }
  });
  const dispatch = useDispatch();

  function addTaxon() {
    dispatch(addTaxonThunk(tree_detail.tree_id)).then(res => {
      if (res.status === 200) {
        toast.success("Added Taxon");
      } else {
        toast.error("Couldn't Add Taxon");
      }
    });
  }

  return (
    <>
      <Form.Label style={{ margin: "1rem 0 0 0" }}>Scientific Names</Form.Label>
      <hr style={{ margin: "0.5rem 0" }} />
      <ol style={{ paddingLeft: "0rem" }}>
        {primary_taxon && (
          <TaxonForm
            taxon={primary_taxon}
            sequenceOptions={taxons.map(t => t.sequence)}
          />
        )}
        {Array.isArray(other_taxa) &&
          other_taxa.map((taxon, idx) => (
            <TaxonForm
              key={idx}
              taxon={taxon}
              sequenceOptions={taxons.map(t => t.sequence)}
            />
          ))}
      </ol>
      <span onClick={addTaxon} className="form-button-primary">
        + Add New Taxon
      </span>
    </>
  );
}

export default Taxons;
